import { GetComponentQuery } from "./generated/graphql"
import { getClient } from "./client"
import GET_COMP_FOR_GEN from "./queries/GET_COMPONENTS_FOR_GEN"

const PAGE_SIZE = 100

/**
 * Fetches all component descendants for a given route by paginating through
 * the GraphQL cursor-based connection. This ensures no items are silently
 * dropped when the total count exceeds a single page size.
 */
export async function fetchAllComponents(
  route: string,
  culture: string,
): Promise<GetComponentQuery> {
  const allEdges: NonNullable<
    NonNullable<GetComponentQuery["components"]>["edges"]
  > = []

  let hasNextPage = true
  let afterCursor: string | undefined

  while (hasNextPage) {
    const { data } = await getClient().query<GetComponentQuery>({
      query: GET_COMP_FOR_GEN,
      variables: {
        route,
        culture,
        first: PAGE_SIZE,
        ...(afterCursor ? { after: afterCursor } : {}),
      },
    })

    const edges = data.components?.edges || []
    allEdges.push(...edges)

    const pageInfo = (data.components as any)?.pageInfo
    hasNextPage = pageInfo?.hasNextPage ?? false
    afterCursor = pageInfo?.endCursor ?? undefined
  }

  // Return a shape matching GetComponentQuery so callers like transformMany
  // can process it without changes.
  return {
    components: {
      edges: allEdges,
    },
  } as GetComponentQuery
}
